import { render } from "./index.vue?vue&type=template&id=4028b4c6"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/settings/feedbackTag/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4028b4c6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4028b4c6', __exports__)) {
    console.log('reload')
    api.reload('4028b4c6', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=4028b4c6", () => {
    console.log('re-render')
    api.rerender('4028b4c6', render)
  })

}


export default __exports__